import Colors from './Colors'

const FontStyles = {
    size8: {fontSize: 8},
    size9: {fontSize: 9},
    size10: {fontSize: 10},
    size11: {fontSize: 11},
    size12: {fontSize: 12},
    size13: {fontSize: 13},
    size14: {fontSize: 14},
    size15: {fontSize: 15},
    size16: {fontSize: 16},
    size17: {fontSize: 17},
    size18: {fontSize: 18},
    size20: {fontSize: 20},
    size22: {fontSize: 22},
    size24: {fontSize: 24},
    size26: {fontSize: 26},
    size28: {fontSize: 28},
    lh10: {lineHeight: 10},
    lh12: {lineHeight: 12},
    lh13: {lineHeight: 13},
    lh14: {lineHeight: 14},
    lh15: {lineHeight: 15},
    lh16: {lineHeight: 16},
    lh18: {lineHeight: 18},
    lh20: {lineHeight: 20},
    lh22: {lineHeight: 22},
    lh24: {lineHeight: 24},
    lh26: {lineHeight: 26},
    lh28: {lineHeight: 28},
    lh30: {lineHeight: 30},
    lh34: {lineHeight: 34},
    lh38: {lineHeight: 38},
    lh40: {lineHeight: 40},
    lh46: {lineHeight: 46},
    default: {color: Colors.tintColor},
    white: {color: Colors.whiteColor},
    dark: {color: Colors.darkTextColor},
    gray: {color: Colors.gray[600]},
    bold: {fontFamily: 'inter-bold'},
    semibold: {fontFamily: 'inter-semibold'},
    medium: {fontFamily: 'inter-medium'},
    normal: {fontFamily: 'inter-regular'},
    light: {fontFamily: 'inter-light'},
    uppercase: {textTransform: 'uppercase'},
    lowercase: {textTransform: 'lowercase'},
    capitalize: {textTransform: 'capitalize'},
    opacity70: {opacity: 0.7},
    opacity10: {opacity: 1},
}

export default FontStyles